import React from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import Line from "components/Charts/Line";
import { getDisplayValue } from "components/Charts/Donut/helper";
import ExternalExamFormLinks from "../ExternalExamFormLinks";
import ExamRequirementStatus from "../ExamRequirementStatus";
import { mobileExamTypeLabels } from "../options";

import useStyles from "./styles";

interface IProps {
  examRequirement: racehorse360.IHorseExamRequirement;
  value: number;
  daysOff: number;
  onExamRequirementUpdate: (
    id: string,
    patch: racehorse360.IHorseExamRequirement
  ) => void;
  customValue?: string;
}

const MobileDefautExamRequirement = (props: IProps) => {
  const {
    examRequirement,
    value,
    daysOff,
    onExamRequirementUpdate,
    customValue
  } = props;

  const classes = useStyles();

  const titleValue = getDisplayValue(value, customValue);
  const examLabel = `${daysOff} ${
    mobileExamTypeLabels[examRequirement.type.code]
  }`;

  return (
    <div className={classes.mobileRoot}>
      <div className={classes.mobileHeader}>
        <div className={classes.horseName}>{examRequirement.horse.name}</div>
      </div>
      <Line
        className={classes.lineWidget}
        value={value}
        capacity={0}
        title={titleValue}
      />
      <div className={classes.mobileFooter}>
        <div className={classes.horseExamInfo}>
          <span className={classes.examLabel}>{examLabel}</span>
          <ExternalExamFormLinks
            examRequirementTypeCode={examRequirement.type.code}
          />
        </div>
        <ExamRequirementStatus
          examRequirement={examRequirement}
          onExamRequirementUpdate={onExamRequirementUpdate}
        />
      </div>
    </div>
  );
};

export default React.memo(MobileDefautExamRequirement);
